<template>
  <section class="d-flex align-items-center" id="wrap">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 text-center">
          <h2>{{ data.message }}</h2>
        </div>
        <div class="col-2" id="steps"><img class="img-fluid" src="../assets/img/error.svg"></div>
        <div class="col-12" id="button-ok"><a class="btn btn-comenzar" href="#" @click="toIndex">RESTART</a></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "StepError",
  props:{
    data: {}
  },methods: {
    toIndex(){
      this.$emit('nextStep','MainContent');
    }
  },emits: ['nextStep'],
}
</script>

<style scoped>

</style>